import React, { useState, useEffect } from 'react';
import { X, CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react';
import './Notification.css';

const icons = {
  success: <CheckCircle />,
  error: <XCircle />,
  warning: <AlertTriangle />,
  info: <Info />,
};

const Notification = ({ open, message, severity = 'info', title, onClose, autoHideDuration = 5000 }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (!open) {
      setIsExiting(false);
      return;
    }

    const timer = setTimeout(() => {
      handleClose();
    }, autoHideDuration);

    return () => clearTimeout(timer);
  }, [open, autoHideDuration, onClose]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      onClose();
      setIsExiting(false);
    }, 300); // Duration of the slideOut animation
  };

  if (!open && !isExiting) {
    return null;
  }

  const IconComponent = icons[severity] || icons.info;

  return (
    <div className={`notification-snackbar ${isExiting ? 'exiting' : ''}`}>
      <div className={`notification-alert ${severity}`}>
        <div className="icon">{IconComponent}</div>
        <div className="notification-content">
          {title && <p className="notification-title">{title}</p>}
          <p className="notification-message">{message}</p>
        </div>
        <button onClick={handleClose} className="notification-close-btn">
          <X size={20} />
        </button>
      </div>
    </div>
  );
};

export default Notification;
